import { render, staticRenderFns } from "./HistoryPanel.vue?vue&type=template&id=57f48b2a&scoped=true&"
import script from "./HistoryPanel.vue?vue&type=script&lang=js&"
export * from "./HistoryPanel.vue?vue&type=script&lang=js&"
import style0 from "./HistoryPanel.vue?vue&type=style&index=0&id=57f48b2a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f48b2a",
  null
  
)

export default component.exports